import { getDocumentsWithToken } from "@services/azureDataApi";
import { SasTokenPrefix } from "@services/user/types";
import { useMutation } from "@tanstack/react-query";
import { runInquiry } from "@telemetry/runInquiry";

export const useDownloadMovementServiceDocument = ({
  movementId,
}: { movementId?: string } = {}) => {
  const documentMutation = useMutation({
    mutationFn: async ({ url }: { service: string; url: string }) => {
      return getDocumentsWithToken(url, SasTokenPrefix.MOVEMENT_SERVICE);
    },
  });

  const handleDownload = async (service: string, documentUrl: string, filename?: string) => {
    try {
      if (!documentUrl) {
        console.error("Document URL is required");
        return;
      }

      await runInquiry(
        {
          module: "vessel_call",
          screen: "MovementServicePreview",
          action: "download_movement_service_document",
          entityType: "movement_service",
          entityId: movementId,
        },
        async () => {
          const blob = await documentMutation.mutateAsync({ service, url: documentUrl });
          const defaultName = filename || "document.pdf";
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = defaultName;
          a.click();
          window.URL.revokeObjectURL(url);
        },
      );
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handlePreview = async (service: string, documentUrl: string) => {
    try {
      if (!documentUrl) {
        console.error("Document URL is required");
        return;
      }

      await runInquiry(
        {
          module: "vessel_call",
          screen: "MovementServicePreview",
          action: "preview_movement_service_document",
          entityType: "movement_service",
          entityId: movementId,
        },
        async () => {
          const blob = await documentMutation.mutateAsync({ service, url: documentUrl });
          const objUrl = URL.createObjectURL(blob);
          window.open(objUrl, "_blank", "noopener,noreferrer");
        },
      );
    } catch (err) {
      console.error("Preview failed:", err);
    }
  };

  return {
    handleDownload,
    handlePreview,
    isPending: documentMutation.isPending,
    isError: documentMutation.isError,
    error: documentMutation.error,
  };
};
